/**
 * If the value is empty outputs the placeholder text.
 */

export default (Vue) => {
	Vue.filter('inv-placeholder', (value, placeholder) => {
		return replace(value, placeholder);
	});

	Vue.prototype.$invPlaceholder = (value, placeholder) => {
		return replace(value, placeholder);
	};

	/**
	 * Output a default value if the input is empty.
	 *
	 * @param {string} value
	 * @param {string} placeholder
	 */
	function replace(value, placeholder) {
		return (value === undefined || value === '' || value === null)
			? placeholder
			: value;
	}
};